import React, { FC } from 'react';
import { Price as PriceType } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { Body3 } from '@common/components/Typography';
import { Price } from '../../../../../Price';
import { PricingTypeWrapper } from './PricingType.styles';

export enum PricingTypeEnum {
  per_person_per_stay = 'per_person_per_stay',
  per_person_per_night = 'per_person_per_night',
  per_stay = 'per_stay',
  per_night = 'per_night',
}

type PricingTypeProps = {
  pricingType?: PricingTypeEnum;
  pricePerNight?: PriceType;
  price?: PriceType;
  quantityLabel?: string | null;
};
export const PricingType: FC<PricingTypeProps> = ({
  pricingType,
  quantityLabel,
  price,
  pricePerNight,
}) => {
  const { t } = useTranslations();

  return pricingType ? (
    <PricingTypeWrapper data-testid="pricing-type">
      <Body3>
        {pricingType === 'per_stay' || pricingType === 'per_person_per_stay' ? (
          <Price price={price} />
        ) : (
          <Price price={pricePerNight} />
        )}{' '}
      </Body3>
      {t(pricingType, { quantity: quantityLabel || t('room.extras.guestQuantity') })}
    </PricingTypeWrapper>
  ) : null;
};
